// --- Core ---
import {FormattedMessage} from "react-intl";
// --- Material UI ---
import {ListItemIcon, ListItemText} from "@mui/material";
// --- SaniQ ---
import {Locale, LocaleDefinition} from "src/config/i18n";

interface LocaleItemContentProps {
  definition: LocaleDefinition;
  showSecondary?: boolean;
}

const LocaleItemContent = ({definition: {flag, name, secondary}, showSecondary}: LocaleItemContentProps) => (
  <>
    <ListItemIcon>
      <img src={flag} alt={name}/>
    </ListItemIcon>
    <ListItemText
      primary={name}
      secondary={showSecondary && secondary}
      slotProps={{secondary: {style: {whiteSpace: "break-spaces"}}}}
    />
  </>
);

interface LocaleNameProps {
  locale: Locale;
}

const LocaleName = ({locale}: LocaleNameProps) => (
  <FormattedMessage
    id={"system.locales"}
    defaultMessage={"{locale, select, de{German} el{Greek} en{English} fr{French} it{Italian} nl{Dutch} fi{Finnish} ru{Russian} other{Unknown}}"}
    values={{locale}}
  />
);

export {
  LocaleItemContent,
  LocaleItemContentProps,
  LocaleName
};
